import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchFormLookups } from "../Services/fetchFormLookups";

export default function useFormLookups({ countryId }) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: ["serviceOperation", "formLookups", { countryId }],
    queryFn: () => fetchFormLookups({ accessToken, countryId }),
    staleTime: Infinity,
    enabled: !!countryId && !!accessToken,
    retry: false,
  });
}
